import { default as AddIconContact } from "@mui/icons-material/AddCircleOutlineRounded";
import { MuiButtonTertiary } from "..";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { ButtonWithIconWrapper } from "./ButtonWithIcon.style";
import { SvgIconProps } from "@mui/material";

type MuiIconType = React.ElementType<SvgIconProps>;
type SvgIconType = React.FC<React.SVGProps<SVGSVGElement>>;

type IconType = MuiIconType | SvgIconType;

interface ButtonWithIconProps {
  buttonText: string;
  onActionClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  ActionIcon?: IconType;
  disabled?: boolean;
}

export const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  buttonText,
  onActionClick,
  ActionIcon = AddIconContact,
  disabled = false,
  ...rest
}) => {
  return (
    <ButtonWithIconWrapper>
      <MuiButtonTertiary
        id={COMPONENT_IDS.COMMON_HEADER_ACTION_BUTTON}
        className="button-with-icon-button"
        onClick={onActionClick}
        disabled={disabled}
        {...rest}
      >
        <ActionIcon
          id={`${buttonText}-icon`}
          color="primary"
          className="button-with-icon-icon"
        />
        {buttonText}
      </MuiButtonTertiary>
    </ButtonWithIconWrapper>
  );
};
